import React, { Component, Children } from 'react';
import Container from '../../components/Container';
import { Grid, Checkbox,List, ListItem,ListItemIcon, Radio, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';
import { BackOnPrimaryIcon, PlaceActiveIcon, ArrowRightIcon, ArrowDownIcon } from '../../components/icons';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, TextFieldWithSelect, SelectComponent} from '../../components/FormElement';
import validators from '../../utils/validators';
import ButtonCustom from '../../components/ButtonCustom';
import {address_types, connection, domainName} from '../../../portal.config'
import {addressCountries} from '../../../portal.menu.config'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import DividerCustom from '../../components/Divider'
import { getCountries, getCountryDefaultByCode, getOrderingCountries } from '../../utils/common';
import countries from '../../../countries';
const styles = theme => ({
    bg_type_address: {
        padding: theme.spacing(1,3,1,3),
        borderRadius: theme.spacing(4),
        borderWidth: 1,
        backgroundColor: theme.palette.success.light,
        borderColor: theme.palette.border.success,
    },
    select_address:{
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        borderRadius: 24,
        height: 48,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.secondary,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        marginTop: theme.spacing(1),
        cursor: 'pointer'
    },
    icon: {
        borderRadius: 4,
        width: 18,
        height: 18,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
          outline: '2px auto rgba(19,124,189,.6)',
          outlineOffset: 2,
        },
        'input:hover ~ &': {
          backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
          boxShadow: 'none',
          background: 'rgba(206,217,224,.5)',
        },
      },
      checkedIcon: {
        borderRadius: 4,
        backgroundColor: theme.palette.primary.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
          display: 'block',
          width: 18,
          height: 18,
          
          backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
          content: '""',
        },
        'input:hover ~ &': {
          backgroundColor: theme.palette.primary.main,
        },
      },
    button_save: {
        marginTop: theme.spacing(4)
    },
    address_done:{
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        borderRadius: 24,
        //height: 48,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.secondary,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        marginTop: theme.spacing(8),

    },
    bordered:{
        //border: '1px solid',
        borderColor: theme.palette.border.secondary,

       // borderBottomWidth: variables.borderWidth,
        borderBottomColor: '1px solid',



    }
});
function AddAddressesView(props) {
    const {classes, t, address_info, onSubmit,onSelectAddress, showLoading, mode, onChangeIsPrimary, isPrimary, onSelectTypeAddress, isSelected, countryCodeDefault} = props
    //console.log('AddAddressesView address_info==',address_info)
    return (
        <div>
            <DrawerCustom 
                open={props.open} 
                onClose={props.onClose}
                title = {mode==='add'?t('new_address_title'):t('edit_address_title')}
                enableBack
                children={<AddAddresses classes={classes} t={t} 
                                address_info={address_info} 
                                onClose={props.onClose} 
                                onClickItem = {props.onClickItem} 
                                onSubmit={onSubmit}
                                onSelectAddress = {onSelectAddress}
                                showLoading = {showLoading}
                                mode={mode}
                                onChangeIsPrimary = {onChangeIsPrimary}
                                isPrimary = {isPrimary}
                                countryCodeDefault={countryCodeDefault}
                                onSelectTypeAddress = {onSelectTypeAddress}
                                isSelected = {isSelected}/>}/>
    </div>
    );
}
function AddAddresses(props) {
    const { t, classes, onClose, address_info, onSelectAddress, showLoading,mode, onChangeIsPrimary,onSelectTypeAddress,isSelected, countryCodeDefault} = props;
    let country = getCountryDefaultByCode(address_info.country_code ==='CY'? 'CYP':address_info.country_code)
    console.log('countryCodeDefault===', countryCodeDefault)
    let isEditAddress = domainName === 'ayna' ? true : false;
    let country_code = address_info&&address_info.country_code?address_info.country_code:null;
    if(domainName === 'ayna' && countryCodeDefault){
            country_code = countryCodeDefault;
    }
    let agreement_countries = domainName === 'ayna' ? getCountries() : countries;
    return (
        <Grid item>
            <Grid xs={12} item container justify='center'>
                {showLoading?<CustomizedCircularProgress/>:null}
            </Grid>
                <Form
                onSubmit={props.onSubmit}
                render={({ handleSubmit, reset, submitting, pristine, values }) => (
                    <Grid xs={12} container item  justify='center' className={classes.marginTop}>
                        {domainName !== 'ayna' && <Grid xs={12} item container alignItems='center' className={classes.select_address}  onClick={()=>onSelectAddress()} id="add_address_select_address">
                            <Grid xs={1} item container justify='flex-start'>
                                <PlaceActiveIcon/>
                            </Grid>
                            <Grid xs={10} item> 
                                <CustomTypo mg_left_sm color='primary'>{t('select_address')}</CustomTypo>
                            </Grid>    
                            <Grid xs={1} item container justify='flex-end'>
                                <KeyboardArrowRightIcon/>
                            </Grid>    
                        </Grid>}
                        {mode == 'edit'&& !isSelected && <Grid item xs ={12} className={classes.address_done}>
                            {address_info&&address_info.address_type &&<Grid item>
                                <CustomTypo mg_top_xl mg_bottom_sm>{t('type')} {address_info&&address_info.address_type?address_info.address_type:address_types[0].value}</CustomTypo>
                                <DividerCustom fullWidth/>
                            </Grid>}                                        
                            {address_info&&address_info.address_name &&<Grid item>
                                <CustomTypo mg_top_sm mg_bottom_sm>{address_info&&address_info.address_name?address_info.address_name:null}</CustomTypo>
                                <DividerCustom fullWidth/>
                            </Grid>}
                            {address_info&&address_info.address_line_1 && <Grid item>
                                <CustomTypo mg_top_sm mg_bottom_sm>{address_info&&address_info.address_line_1?address_info.address_line_1:null}</CustomTypo>
                                <DividerCustom fullWidth/>
                            </Grid>}                                        
                            {address_info&&address_info.town_city &&<Grid item>
                                <CustomTypo mg_top_sm mg_bottom_sm>{address_info&&address_info.town_city?address_info.town_city:null}</CustomTypo>
                                <DividerCustom fullWidth/>
                            </Grid>}
                            {country&&<Grid item>
                                <CustomTypo mg_top_sm mg_bottom_sm>{country?country.label:''}</CustomTypo>
                                <DividerCustom fullWidth/>
                            </Grid>}
                            <CustomTypo mg_top_sm mg_bottom_xl>{address_info&&address_info.postal_code?address_info.postal_code:null}</CustomTypo>
                        </Grid>}
                        {((mode == 'add' && isSelected) || (mode == 'edit'&&isSelected)) && <Grid item xs={12} container> 
                            <Grid xs={12} item container>
                                <Field
                                    name="address_name"
                                    component={TextFieldComponent}
                                    label={t('address_name')} 
                                    defaultValue={address_info&&address_info.address_name?address_info.address_name:null}
                                    // isEdit={mode==='add'?true:false}
                                    isEdit={true}
                                    color='default'
                                    validate={validators.composeValidators(validators.required)}
                                />
                            </Grid>
                            <Grid xs={12} item container>
                                <Field
                                    name="address_type"
                                    component={SelectComponent}
                                    label={t('type')}
                                    selectData={address_types}
                                    defaultValueSelect={address_types[0].value}
                                    valueSelect={address_info&&address_info.address_type?address_info.address_type:address_types[0].value}
                                    onSelectedChange={(event)=>onSelectTypeAddress('address_type',event)}
                                    color='default'
                                    placeholder = {t('Select')}
                                    isEdit={mode==='add'?true:false}
                                />
                            </Grid>
                            <Grid xs={12} item container>
                                <Field
                                    name="address_line_1"
                                    component={TextFieldComponent}
                                    label={t('address_line')+' 1'} 
                                    defaultValue={address_info&&address_info.address_line_1?address_info.address_line_1:null}
                                    // isEdit={mode==='add'?true:false}
                                    isEdit={true}
                                    color='default'
                                    validate={validators.composeValidators(validators.required)}
                                />
                            </Grid>
                            <Grid xs={12} item container>
                                <Field
                                    name="address_line_2"
                                    component={TextFieldComponent}
                                    label={t('address_line')+' 2 ' + t('address_line_suggest')}
                                    defaultValue={address_info&&address_info.address_line_2?address_info.address_line_2:null}
                                    // isEdit={mode==='add'?true:false}
                                    isEdit={true}
                                    color='default'
                                />
                            </Grid>
                            <Grid xs={12} item container>
                                <Grid xs={12} sm ={5} item container justify='flex-start'>
                                    <Field
                                        name="city"
                                        component={TextFieldComponent}
                                        label={t('city')}
                                        valuez={address_info&&address_info.town_city?address_info.town_city:null}
                                        // isEdit={mode==='add'?true:false}
                                        isEdit={isEditAddress}
                                        color='default'
                                        validate={isEditAddress ? validators.composeValidators(validators.required) : null}
                                    />
                                </Grid>
                                <Grid xs={0} sm={2}></Grid>
                                <Grid xs={12} sm={5} item container justify='flex-end'>
                                    <Field
                                        name="postal_code"
                                        component={TextFieldComponent}
                                        label={t('postal_code')}
                                        valuez={address_info&&address_info.postal_code?address_info.postal_code:null}
                                        //isEdit={mode==='add'?true:false}
                                        isEdit={true}
                                        color='default'
                                        validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                    />
                                </Grid>                                  
                            </Grid>
                            <Grid xs={12} item container>
                                <Grid xs={12} sm={5}item container justify='flex-start'>
                                    <Field
                                        name="state"
                                        component={TextFieldComponent}
                                        label={t('state')}
                                        valuez={address_info&&address_info.state_province_county?address_info.state_province_county:null}
                                        // isEdit={mode==='add'?true:false}
                                        isEdit={isEditAddress}
                                        color='default'
                                        //validate={validators.composeValidators(validators.required)}
                                    />
                                </Grid>
                                <Grid xs={0} sm={2}></Grid>
                                <Grid xs={12} sm={5} item container justify='flex-end'>
                                    <Field
                                        name="country_code"
                                        component={SelectComponent}
                                        label={t('country')}
                                        selectData={agreement_countries}
                                        defaultValueSelect={country_code}
                                        valueSelect={address_info && address_info.country_code ? address_info.country_code : (domainName == 'ayna' && countryCodeDefault ? countryCodeDefault : addressCountries[0].value)}
                                        onSelectedChange={(event) => onSelectTypeAddress('country_code', event)}
                                        color='default'
                                        placeholder={t('Select')}
                                        //isEdit={mode==='add'?true:false}
                                        isEdit={isEditAddress}
                                    />
                                </Grid>                                  
                            </Grid>
                            <Grid xs={12} item container alignItems='center'>
                                <Checkbox
                                    checked={address_info.is_primary}
                                    onChange={onChangeIsPrimary}
                                    color="primary"
                                    name="set_as_primary"
                                    icon={<span className={classes.icon} />}
                                    checkedIcon={<span className={ classes.checkedIcon} />}
                                />
                                <CustomTypo light>{t('set_as_primary')}</CustomTypo>
                            </Grid>
                            <Grid xs={12} item container justify='center' className={classes.button_save}>
                                <ButtonCustom color='primary' fullWidth onClick={handleSubmit} id="add_address_btn_save">{t('btn_save')}</ButtonCustom>
                            </Grid>
                        </Grid>}
                    </Grid>
                )} />
        </Grid>
    )
}

export default withStyles(styles)(withTranslation()(AddAddressesView));